import React from 'react';
import { linkIDs } from '../../../../../services/link-service/links';
import { useProvidersGridContext } from '../../providers-grid-context';
import { DocSection } from '../doc-section';
import messages from './messages';

const providerHasPackingSlipSharingConfigured = (providers) => providers?.some((provider) => provider.packingSlipSharing?.isEnabled);

export const PackingSlipSharingDescription = () => {
  const { vendors, fulfillmentProviders } = useProvidersGridContext();

  const isPackingSlipSharingConfigured = () => {
    return (
      providerHasPackingSlipSharingConfigured(vendors?.activeProviders) ||
      providerHasPackingSlipSharingConfigured(fulfillmentProviders?.activeProviders) ||
      providerHasPackingSlipSharingConfigured(vendors?.pendingInvitations)
    );
  };

  if (isPackingSlipSharingConfigured()) {
    return null;
  }

  return <DocSection articleId={linkIDs.PackingSlipSharing} descriptionMessage={messages.packingSlipSharingDescription} />;
};
